// extracted by mini-css-extract-plugin
export var fadeIn = "_ge-1";
export var modalContent = "_ge-3";
export var overlay = "_ge-0";
export var popoverContent = "_ge-2";
export var results = "_ge-5";
export var searchInputWrapper = "_ge-4";